import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dropdownTitle: {
		id: 'personal-settings-preference-fields.common.mime-type.dropdown-title',
		defaultMessage: 'Email notifications format',
		description: 'Dropdown label for email notifications format.',
	},
	optionText: {
		id: 'personal-settings-preference-fields.common.mime-type.option-text',
		defaultMessage: 'Text',
		description: 'Dropdown option. Sets email notifications format to text.',
	},
	description: {
		id: 'personal-settings-preference-fields.common.mime-type.description',
		defaultMessage:
			'Your email notification format is set to HTML since your organization has signed up for HIPAA',
		description:
			'Text which explains that the notification format has been set to HTML due to HIPAA',
	},
	mimeTypeFieldLabel: {
		id: 'personal-settings-preference-fields.common.mime-type.mime-type-field-label',
		defaultMessage: 'Email format',
		description: 'Dropdown label for email format.',
	},
});
